import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DateFormatService } from 'src/app/modules/core/services/dateFormat.service';
import { SessionService } from 'src/app/modules/core/services/session.service';

@Injectable()
export class NgbDatepickerCustomI18n extends NgbDatepickerI18n {
	constructor(
		private dateFormatService: DateFormatService,
		private sessionService: SessionService,
		private translateService: TranslateService
	) {
		super();
	}

	getWeekdayShortName(weekday: number): string {
		return this.translateService.instant('inputDate.weekdayShort.' + (weekday - 1));
	}

	getMonthShortName(month: number, year?: number): string {
		return this.translateService.instant('inputDate.monthShort.' + (month - 1));
	}

	getMonthFullName(month: number, year?: number): string {
		return this.translateService.instant('inputDate.month' + (month - 1));
	}

	getDayAriaLabel(date: NgbDateStruct): string {
		const newDate = new Date(date.year, date.month, date.day);
		return this.dateFormatService.formatDate(newDate);
	}
}
